module.exports = __webpack_public_path__ + "media/images/profile_camera-ef271b69378b2111a703f47fdc9fcd14.png";